import {
  FileStatus,
  type LibraryFile,
} from "@/pages/library_v2/components/filesView/types";

import { useRef } from "react";

import { DownloadAction } from "./downloadAction";
import { ExtraFileActions } from "./extraActions";
import { MoveToFolderAction } from "./moveToFolderAction";

type Props = {
  file: LibraryFile;
  tooltipPlacement: "bottom" | "top";
  setIsRenaming: (value: boolean) => void;
};

export const FileActions: React.FC<Props> = ({
  file,
  tooltipPlacement,
  setIsRenaming,
}) => {
  const moveButtonRef = useRef<HTMLButtonElement>(null);
  const downloadButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="flex items-center justify-end gap-[2px]">
      {file.status === FileStatus.PUBLISHED && (
        <MoveToFolderAction
          file={file}
          tooltipPlacement={tooltipPlacement}
          moveButtonRef={moveButtonRef}
        />
      )}

      <DownloadAction
        file={file}
        tooltipPlacement={tooltipPlacement}
        downloadButtonRef={downloadButtonRef}
      />

      <ExtraFileActions
        file={file}
        tooltipPlacement={tooltipPlacement}
        moveButtonRef={moveButtonRef}
        downloadButtonRef={downloadButtonRef}
        setIsRenaming={setIsRenaming}
      />
    </div>
  );
};
